import ReceptionistZReport from '../receptionist/ZReport';

/** Admin Detailed Report — SALE REPORT + manual Petty Cash Detail. */
export default function AdminDetailedReport() {
  return (
    <ReceptionistZReport
      title="Detailed Report"
      subtitle="Sale report by package, then petty cash (opening manual; sales & expenses auto)"
      badgeLabel="Detailed report"
      manualPettyCash
    />
  );
}
